/**
 * @description 유효한 ID인지 확인
 * @param id 확인할 ID
 */
export const isValidId = (id) => {
    return typeof id === "number" && id > 0;
};
